<template lang="pug">
    article.career(v-if='slides')
        NextPageTrigger(v-observe-visibility='e => {reachStartTrigger = e}', :triggerstart='reachStartTrigger', url='/we')

        .career__wellcome-img
            BlockVisibilityTrigger(:theme='"white"')
            .career__wrapper
                .career__slide

                    .slide__bg
                        img(:src='require("@/assets/img/career/topbg.jpg")', alt='photo')

                    .slide__content.slide__content--main
                        h2.h1.slide__title
                            span(v-html='wellcomeText')

                .career__arrow-scroll
                    svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                        path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')

            BlockVisibilityTrigger(:theme='"white"', :bottom='true')

        .career__wellcome-text
            BlockVisibilityTrigger(:theme='"black"')
            .career__wellcome-wrapper
                ul.cases.cases--features
                    li.case(v-for='(point, pointIndex) in wellcomePoints', v-observe-visibility='visibilityChanged')
                        img.case-image(:src='require(`@/assets/img/career/icons/icon_${pointIndex}.svg`)')
                        h3.case-heading.case-heading--clean(v-html='point')

        .career__possibilities
            .career__wellcome-wrapper
                h3.career__possibilities-heading.h1.h1--color-main.career__title(v-html='possibilities.text')
                ul.cases.cases--features
                    li.case(v-for='(point, pointIndex) in possibilities.list', v-observe-visibility='visibilityChanged')
                        img.case-image(:src='require(`@/assets/img/career/icons/second_icon_${pointIndex}.svg`)')
                        h3.case-heading.case-heading--clean(v-html='point')

            BlockVisibilityTrigger(:theme='"black"', :bottom='true')


        .career__container.swiper-container(ref='swiperContainer')
            BlockVisibilityTrigger(:theme='"white"')

            .career__wrapper.swiper-wrapper
                .career__slide.swiper-slide(v-for='({title, description, bg} = item, index) in slides')
                    .slide__bg
                        img(:src='require(`@/assets/img/career/${bg}`)', alt='photo')

                    .slide__content
                        h2.h1.slide__title
                            span(v-html='title')
                        .slide__description(v-html='description')
            .slide__nav
                h3.slide__label {{labels.bullets}}
                .swiper-pagination

            .career__nav-button.career__nav-button--prev
                svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')
            .career__nav-button.career__nav-button--next
                svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')

            .career__arrow-scroll
                svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')

            BlockVisibilityTrigger(:theme='"white"', :bottom='true')

        .career__content
            BlockVisibilityTrigger(:theme='"black"')

            .career__team
                h3.h1.h1--color-main.career__title(v-html='career.team.title')
                .career__list
                    .career__item(v-for='item in career.team.texts', v-observe-visibility='visibilityChanged')
                        .career__subtitle.career__subtitle--with-circle(v-html='item.title')
                        .career__text(v-html='item.text')

            .career__mission(v-observe-visibility='visibilityChanged')
                h3.h1.h1--color-main.career__title(v-html='career.mission.title')
                .career__lead(v-html='career.mission.lead')
                .career__text(v-html='career.mission.text')

            .career__people(v-if="career.people")
                h3.h1.h1--color-main.career__title(v-html='career.people.title')

                ul.cases.cases--features
                    li.case(v-for='item in career.people.list', v-observe-visibility='visibilityChanged')
                        img.case-image(:src='require(`@/assets/img/career/${item.photo}.png`)', :alt='item.name')
                        p.case-client(v-html='item.field')
                        h3.case-heading(v-html='item.motto')
                        p.case-text(v-html='item.text')
                        .case-name(v-html='item.name + ","')
                        .case-position(v-html='item.position')

        // #career(ref='career', v-observe-visibility='{callback: careerReached, once: true}')

        .career__form.feedback-top(
            v-if="contact",
            v-observe-visibility='visibilityChanged'
        )
            BlockVisibilityTrigger(:theme='"black"')
            FormHeadingWrapper(
                :title="contact.title",
                :subtitle="contact.subtitle || null"
            )

        .career__container.swiper-container(ref='swiperContainer1')
            BlockVisibilityTrigger(:theme='"white"')

            .career__wrapper.swiper-wrapper
                .career__slide.swiper-slide(v-for='({title, description, bg} = item, index) in slides1')
                    .slide__bg
                        img(:src='require(`@/assets/img/career/${bg}`)', alt='photo')

                    .slide__content
                        h2.h1.slide__title
                            span(v-html='title')
                        .slide__description(v-html='description')
            .slide__nav
                //- h3.slide__label {{labels.bullets}}
                .swiper-pagination

            .career__nav-button.career__nav-button--prev
                svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')
            .career__nav-button.career__nav-button--next
                svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')

            BlockVisibilityTrigger(:theme='"white"', :bottom='true')

        NextPageHelper(:trigger='reachEndTrigger', urltext='Контакты', isBlack=true)

        Footer

        NextPageTrigger(v-observe-visibility='e => {reachEndTrigger = e}', :trigger='reachEndTrigger', url='/contacts')

</template>

<script>
import Swiper, {Pagination, Keyboard, EffectFade, Navigation} from 'swiper';
Swiper.use([Pagination, Keyboard, EffectFade, Navigation]);
import Footer from '../components/Footer.vue';
import NextPageTrigger from '../components/NextPageTrigger.vue';
import NextPageHelper from '../components/NextPageHelper.vue';
import BlockVisibilityTrigger from '../components/BlockVisibilityTrigger.vue';

import careerData from '../assets/data/career.json';
import assetsData from '../assets/data/assets.json';
import FormHeadingWrapper from '@/components/FormHeadingWrapper.vue';

export default {
    name: 'Career',

    components: {
        FormHeadingWrapper,
        Footer,
        NextPageTrigger,
        NextPageHelper,
        BlockVisibilityTrigger
    },

    data() {
        return {
            swiper: [],
            wellcomeText: careerData.wellcome.text,
            wellcomePoints: careerData.wellcome.points.list,
            possibilities: careerData.wellcome.possibilities,
            slides: careerData.slides,
            slides1: careerData.slides1,
            labels: careerData.labels,
            career: careerData,
            assets: assetsData,
            contact: careerData.contact || null,
            listIsActive: false,
            currentAssetID: '',

            reachEndTrigger: false,
            reachStartTrigger: false
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.initSW(this.$refs.swiperContainer, 0);
            this.initSW(this.$refs.swiperContainer1, 1);
        });
    },

    beforeDestroy() {
        this.swiper[0].destroy();
        this.swiper[1].destroy();
    },

    methods: {
        initSW(el, index) {
            this.swiper[index] = new Swiper(el, {
                direction: 'horizontal',
                speed: 1300,
                effect: 'fade',
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                navigation: {
                    nextEl: '.career__nav-button--next',
                    prevEl: '.career__nav-button--prev'
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: false
                }
            });
        },
        visibilityChanged(e, el) {
            if (e) {
                el.target.classList.add('show');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';
@import '../assets/css/base.scss';
@import '../assets/css/animations.scss';

:root {
    --vh: 5.68px;
}

.career {
    position: relative;
    overflow-anchor: auto;

    &__wellcome {
        &-img {
            width: 100%;
            min-height: 100vh;

            @supports (--css: variables) {
                min-height: calc(var(--vh) * 100);
            }
        }

        &-text {
            background: white;
        }
    }

    &__possibilities {
        background: white;
        padding-bottom: 4em;
        padding-top: 4em;
    }

    &__wellcome-text {
        background: white;
        padding-top: 4em;
    }

    &__slide {
        position: relative;
    }

    &__slide.swiper-slide {
        position: relative;
    }

    &__container {
        width: 100%;
        min-height: 100vh;
        perspective: 800px;
        background-color: #232222;
        color: var(--color-accent-text);

        @supports (--css: variables) {
            min-height: calc(var(--vh) * 100);
        }
    }

    &__wrapper {
        position: relative;
        transform-style: preserve-3d;
        overflow: hidden;
    }

    .swiper-pagination {
        position: relative;
    }

    .swiper-pagination-bullet {
        width: 0.6em;
        height: 0.6em;
        background-color: var(--color-main-bg);
        opacity: 0.5;
        margin-right: 1.2em;

        &:last-child {
            margin-right: 0;
        }
    }

    .swiper-pagination-bullet-active {
        opacity: 1;
    }

    &__nav-button {
        position: absolute;
        width: 0.6em;
        height: 1em;
        z-index: 3;
        cursor: pointer;

        @supports (--css: variables) {
            top: calc(var(--vh) * 40);
        }

        cursor: pointer;
        font-size: 2em;
        color: white;
        pointer-events: auto;

        svg {
            width: 30px;
            height: auto;
            fill: white;
        }

        &--prev {
            left: var(--layout-column-width);

            @media (--viewport-tablet) {
                left: 3px;

                svg {
                    width: 20px;
                }
            }

            svg {
                transform: rotate(180deg);
            }
        }

        &--next {
            right: var(--layout-column-width);

            @media (--viewport-tablet) {
                right: 3px;

                svg {
                    width: 20px;
                }
            }
        }
    }

    &__arrow-scroll {
        position: absolute;
        width: 100%;
        height: 0.6em;
        bottom: var(--layout-column-width);
        z-index: 3;
        pointer-events: none;
        text-align: center;
        animation: arrow 1.5s infinite;

        svg {
            width: 30px;
            height: auto;
            fill: white;
            transform: rotate(90deg);
        }
    }

    &__form {
        width: calc(var(--layout-column-width) * 8 + var(--layout-gutter-width) * 7);
        margin: 0 auto;

        @media (--viewport-tablet) {
            width: 100%;
        }
    }

    &__lead {
        font-size: 1.2em;
        line-height: 1.4;
        text-align: center;
        text-transform: uppercase;
        margin-bottom: 1em;
    }

    &__content {
        position: relative;
        background-color: var(--color-main-bg);
        padding-top: 6em;
    }

    &__people,
    &__team,
    &__mission,
    &__wellcome-wrapper {
        width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin: 0 auto;

        @media (--viewport-tablet) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
        }
    }

    &__possibilities {
        padding-top: 6em;
        padding-bottom: 6em;
    }

    &__wellcome-points {
        padding-top: 6em;
    }

    &__wellcome-points,
    &__possibilities-list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-row-gap: 120px;
        grid-column-gap: 30px;
        text-transform: uppercase;

        @media (--viewport-tablet) {
            grid-template-columns: 1fr;
            grid-row-gap: 10vw;
        }
    }

    &__wellcome-point-text,
    &__possibilities-list-item-text {
        font-weight: 500;
    }

    &__people {
        padding-bottom: 4em;
    }

    &__title {
        text-align: center;
        margin-bottom: 1.3em;
        // color: var(--color-accent-text);

        @media (--viewport-tablet) {
            text-align: left;
        }
    }

    &__text {
        margin-bottom: 3em;
        max-width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin-left: auto;
        margin-right: auto;
        text-align: justify;

        @media (--viewport-tablet) {
            max-width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
        }

        p {
            margin-bottom: 1em;
        }

        &--min-margin {
            margin-bottom: 1em;
        }

        &--center {
            text-align: center;
        }
    }

    &__subtitle {
        display: inline-block;
        font-size: 1.4em;
        font-weight: 500;
        line-height: 1.2;
        text-transform: uppercase;
        margin-bottom: 1em;

        &:after {
            content: '';
            position: relative;
            display: block;
            height: 4px;
            width: 100%;
            background-color: currentColor;
            top: 0.25em;
        }

        &--text-block {
            display: block;
        }

        &--with-circle {
            position: relative;

            &:before {
                content: '';
                position: absolute;
                top: -1em;
                right: -1.5em;
                display: inline-block;
                width: 3em;
                height: 3em;
                border-radius: 100%;
                background-color: var(--color-header-bg);
                opacity: 0.3;
                animation: shake-slow 55s -1.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }

            .career__team .career__item:nth-child(2) & {
                &:before {
                    top: -1.1em;
                    left: -1em;
                    width: 2em;
                    height: 2em;
                    animation: shake-slow 40s -4.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
                }
            }

            .career__team .career__item:nth-child(3) & {
                &:before {
                    top: -2em;
                    right: -1.25em;
                    width: 2.5em;
                    height: 2.5em;
                    animation: shake-slow 45s -1.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
                }
            }
        }
    }

    &__list {
        &--column {
            display: flex;
            flex-wrap: wrap;

            .career__item {
                width: 50%;
                padding-right: var(--layout-gutter-width);

                @media (--viewport-tablet) {
                    width: 100%;
                }
            }
        }
    }

    &__item {
        margin-bottom: 1em;
        opacity: 0;
        transform: translateY(50px);

        &.show {
            opacity: 1;
            transform: translateY(0px);
            transition: opacity 1s ease 0.2s, transform 1s cubic-bezier(0.39, 0.575, 0.565, 1) 0.2s;
        }

        &--with-photo {
            padding-left: calc(var(--layout-gutter-width) + var(--layout-column-width));

            @media (--viewport-tablet) {
                padding-left: 0;
            }
        }
    }

    .case {
        opacity: 0;
        transform: translateY(50px);

        &.show {
            opacity: 1;
            transform: translateY(0px);
            transition: opacity 1s ease 0.2s, transform 1s cubic-bezier(0.39, 0.575, 0.565, 1) 0.2s;
        }

        &-heading {
            &--clean {
                border-bottom: none;
            }
        }
    }

    .case-heading.case-heading--with-circle:before {
        background-color: var(--color-main-bg);
    }

    &__photo {
        position: relative;
        left: calc((var(--layout-column-width) + var(--layout-gutter-width)) * -1);
        width: calc(var(--layout-gutter-width) + var(--layout-column-width) * 2);
        margin-bottom: 2em;

        @media (--viewport-tablet) {
            left: 0;
            width: calc(var(--layout-gutter-width) * 6 + var(--layout-column-width) * 6);
            margin-left: auto;
            margin-right: auto;
        }

        img {
            width: 100%;
        }

        &:before {
            content: '';
            position: absolute;
            top: -1.5em;
            right: -2em;
            display: inline-block;
            width: 2.5em;
            height: 2.5em;
            border-radius: 100%;
            background-color: var(--color-accent-text);
            opacity: 0.3;
            animation: shake-slow 150s -4.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
        }

        .career__people .career__item:nth-child(2) & {
            &:before {
                top: auto;
                bottom: -3.5em;
                left: 0.9em;
                width: 2em;
                height: 2em;
                animation: shake-slow 100s -2.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }
        }

        .career__people .career__item:nth-child(3) & {
            &:before {
                top: -2em;
                left: 0;
                width: 2em;
                height: 2em;
                animation: shake-slow 160s -12.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }
        }

        .career__people .career__item:nth-child(4) & {
            &:before {
                top: 0;
                left: auto;
                right: -2em;
                width: 3.5em;
                height: 3.5em;
                animation: shake-slow 120s -16.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }
        }

        .career__people .career__item:nth-child(5) & {
            &:before {
                top: auto;
                bottom: -2.5em;
                left: auto;
                right: -2.5em;
                width: 2.5em;
                height: 2.5em;
                animation: shake-slow 90s -4.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }
        }

        .career__people .career__item:nth-child(6) & {
            &:before {
                top: 50%;
                left: auto;
                right: -3.5em;
                width: 2em;
                height: 2em;
                animation: shake-slow 110s -2.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }
        }

        .career__people .career__item:nth-child(7) & {
            &:before {
                top: -1em;
                left: -3em;
                width: 2.5em;
                height: 2.5em;
                animation: shake-slow 120s -3.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }
        }
    }

    &__field {
        text-transform: uppercase;
        font-family: var(--font-accent);
        opacity: 0.5;
        margin-bottom: 1em;
    }

    &__name,
    &__position {
        font-weight: 350;
    }

    &__position {
        margin-bottom: 2em;
    }

    &__mission {
        padding-bottom: 4em;

        @media (--viewport-tablet) {
            padding-bottom: 3em;
        }
    }

    &__mission,
    &__form {
        position: relative;
        opacity: 0;
        transform: translateY(50px);

        &.show {
            opacity: 1;
            transform: translateY(0px);
            transition: opacity 1s ease 0.2s, transform 1s cubic-bezier(0.39, 0.575, 0.565, 1) 0.2s;
        }
    }

    @keyframes arrow {
        0% {
            opacity: 0;
            transform: translateY(-1em);
        }
        75% {
            opacity: 1;
            transform: translateY(1em);
        }
        90% {
            opacity: 0;
            transform: translateY(1em);
        }
        100% {
            opacity: 0;
            transform: translateY(1em);
        }
    }
}

.slide {
    &__bg {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;

        img {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }

    &__nav {
        position: absolute;
        top: 20vh;
        left: 0;
        width: 100%;
        z-index: 2;

        @supports (--css: variables) {
            top: calc(var(--vh) * 20);
        }

        @media (--viewport-tablet) {
            top: 5em;
        }
    }

    &__label {
        box-sizing: border-box;
        margin: 0 auto;
        text-transform: uppercase;
        opacity: 0.5;
        font-family: var(--font-accent);
        margin-bottom: 1em;
        text-align: center;
    }

    &__content {
        position: relative;
        width: calc(6 * var(--layout-column-width) + 5 * var(--layout-gutter-width));
        margin: 0 auto;
        box-sizing: border-box;

        @supports (--css: variables) {
            min-height: calc(var(--vh) * 100);
            padding-top: calc(var(--vh) * 40);
        }

        @media (--viewport-tablet) {
            width: calc(10 * var(--layout-column-width) + 9 * var(--layout-gutter-width));
            padding-top: 10em;
        }

        &--main {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 0;
        }
    }

    &__title {
        text-align: center;
        min-height: 2.6em;

        @media (--viewport-tablet) {
            margin-bottom: 0.7em;
        }
    }

    &__description {
        text-align: justify;

        @media (--viewport-tablet) {
            text-align: center;
            padding-bottom: 2em;
        }
    }
}

.feedback-top {
    color: var(--color-accent-text);
    padding-top: 4em;

    @media (--viewport-tablet) {
        padding-top: 2em;
    }
}
</style>
